import controller from './orders.controller';
import templateBase from './templates/orders-base.view.html';
import templateT1 from './templates/orders-t1.view.html';
import templateT15 from './templates/orders-t15.view.html';
import templateAD from './templates/orders.view-adaptative.html';

let OrdersComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    
    if(__env.adaptative) {
        return templateAD;
    }
    else {
        if(response.ORDERS.component == 'template_t1'){ return templateT1; }
        if(response.ORDERS.component == 'template_t15'){ return templateT15; }
        else{
            return templateBase;
        }
    }
}

export default OrdersComponent;


// WEBPACK FOOTER //
// ./www/components/orders/orders.component.js